import {
  Component,
  EventEmitter,
  Input,
  Output,
  OnChanges,
  OnInit,
  SimpleChanges,
} from "@angular/core";
import { CoreCommonModule } from "@core/common.module";

@Component({
  standalone: true,
  selector: "app-otp-input",
  imports: [CoreCommonModule],
  templateUrl: "./otp-input.html",
  styleUrls: ["./otp-input.scss"],
})
export class OtpInputComponent implements OnInit, OnChanges {
  /** How many digit boxes to render */
  @Input() length = 6;

  /** Parent sets this true when the server rejects the submitted code */
  @Input() invalid = false;

  /** Message shown under the boxes when invalid */
  @Input() errorMessage = "";

  /** Emits the current joined value on every keystroke (e.g. to enable/disable a submit button) */
  @Output() valueChange = new EventEmitter<string>();

  /** Emits the joined value once every box is filled */
  @Output() complete = new EventEmitter<string>();

  otpValues: string[] = [];

  ngOnInit(): void {
    if (this.otpValues.length !== this.length) {
      this.otpValues = new Array(this.length).fill("");
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["length"] && !changes["length"].firstChange) {
      this.otpValues = new Array(this.length).fill("");
    }
  }

  trackByIndex(index: number): number {
    return index;
  }

  getOtpString(): string {
    return this.otpValues.join("");
  }

  onOtpInput(event: any, index: number): void {
    const input = event.target as HTMLInputElement;
    const value = input.value.replace(/[^0-9]/g, "").slice(-1);
    this.otpValues[index] = value;
    input.value = value;

    if (value && index < this.otpValues.length - 1) {
      const nextInput = document.getElementById(
        this.inputId(index + 1),
      ) as HTMLInputElement;
      nextInput?.focus();
    }

    const current = this.getOtpString();
    this.valueChange.emit(current);

    if (current.length === this.length) {
      this.complete.emit(current);
    }
  }

  onOtpKeyDown(event: KeyboardEvent, index: number): void {
    if (event.key === "Backspace") {
      if (this.otpValues[index]) {
        this.otpValues[index] = "";
        const input = event.target as HTMLInputElement;
        input.value = "";
        this.valueChange.emit(this.getOtpString());
      } else if (index > 0) {
        const prev = document.getElementById(
          this.inputId(index - 1),
        ) as HTMLInputElement;
        prev?.focus();
      }
    }
  }

  inputId(index: number): string {
    return `otp${index}`;
  }

  /** Called by the parent via a template reference variable to reset all boxes after a failed verify */
  clear(): void {
    this.otpValues = new Array(this.length).fill("");
    setTimeout(() => {
      for (let i = 0; i < this.otpValues.length; i++) {
        const input = document.getElementById(this.inputId(i)) as HTMLInputElement;
        if (input) input.value = "";
      }
      const first = document.getElementById(this.inputId(0)) as HTMLInputElement;
      first?.focus();
    }, 0);
  }
}